import React from 'react';
import PropTypes from 'prop-types';
import { RawHtml } from '../../../common/index.jsx';
import {
  StyledModal,
  StyledModalHeader,
} from '../../../common/form/FormElements.jsx';
import { useTranslation } from 'react-i18next';
import { DATETIME_FORMAT_DATE } from '../../../../utils/helpers/CommonHelper.jsx';

const DissertationModal = ({
  visible,
  togglePostModal,
  values,
  studyPrograms,
  isCreate,
}) => {
  const { t } = useTranslation();

  const usedStudyProgram =
    studyPrograms &&
    studyPrograms.find((item) => item.id === values.study_program_id);

  const summaryFileExists =
    values.summary_file !== null && values.summary_file !== '';

  return (
    <>
      {visible && (
        <div className="hp-news-modal-container add-icons-to-file-anchors">
          <StyledModal
            open={visible}
            size="lg"
            onCancel={() => togglePostModal()}
            footer={null}
          >
            <StyledModalHeader>
              <a className={`second-title title`} href="#">
                {values.title || t('--neuvedené--')}
              </a>
            </StyledModalHeader>
            <div style={{ padding: '10px' }}>
              <div>
                <b>{t('Autor')} &nbsp;</b>
                {values.student}
              </div>

              <div>
                <b>{t('Školiteľ')} &nbsp;</b>
                {values.supervisor}
              </div>

              <div>
                <b>{t('Dátum obhajoby')} &nbsp;</b>
                {values.year.format(DATETIME_FORMAT_DATE)}
              </div>

              {usedStudyProgram && (
                <div>
                  <b>{t('Študijný program')} &nbsp;</b>
                  {usedStudyProgram.name}
                </div>
              )}

              <div>
                <b>{t('Oponent 1')} &nbsp;</b>
                {values.reviewer1}
              </div>

              <div>
                <b>{t('Oponent 2')} &nbsp;</b>
                {values.reviewer2}
              </div>

              <div>
                <b>{t('Oponent 3')} &nbsp;</b>
                {values.reviewer3}
              </div>
              <div>
                <div>
                  <b>{t('Abstrakt (slovensky)')} &nbsp;</b>
                </div>
                <RawHtml>{values.abstract_sk}</RawHtml>

                <div>
                  <b>{t('Abstrakt (anglicky)')} &nbsp;</b>
                </div>
                <RawHtml>{values.abstract_en}</RawHtml>
              </div>

              {summaryFileExists ? (
                <div>
                  {isCreate ? (
                    <div>
                      <b>{t('Autoreferát dizertačnej práce')} &nbsp;</b>
                      {values.summary_file.name}
                    </div>
                  ) : (
                    <a href={values.summary_file} target={'blank'}>
                      {t('Autoreferát dizertačnej práce')}
                    </a>
                  )}
                </div>
              ) : (
                ''
              )}
            </div>
          </StyledModal>
        </div>
      )}
    </>
  );
};

DissertationModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  togglePostModal: PropTypes.func.isRequired,
  values: PropTypes.object,
  studyPrograms: PropTypes.array,
  isCreate: PropTypes.bool,
};

export default DissertationModal;
